import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/support_questions';

export default {
  send(support, succ) {
    axios.post(INDEX_URL, support)
      .then(() => { succ(); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/support.js